import React from 'react';
import PropTypes from 'prop-types';
import buttonWrapper from '../../hocs/button/index';
/* eslint-disable */
const Submit = ({ hasErrors, disabled, type, ...props }) => {
  return <button type={type || 'submit'} {...props} disabled={disabled || hasErrors} />;
};

Submit.contextTypes = {
  hasErrors: PropTypes.bool
};


export default buttonWrapper(Submit);



// WEBPACK FOOTER //
// ./src/components/react-validation/components/submit/index.js